var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "nav",
      {
        staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
        staticStyle: { "margin-bottom": "0" },
      },
      [
        _c(
          "button",
          {
            staticClass: "navbar-toggler",
            attrs: {
              type: "button",
              "data-toggle": "collapse",
              "data-target": "#Navigation",
            },
          },
          [_c("span", { staticClass: "navbar-toggler-icon" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse navbar-collapse",
            attrs: { id: "Navigation" },
          },
          [
            _c("ul", { staticClass: "navbar-nav mr-auto" }, [
              _c("li", { staticClass: "nav-item" }, [
                _c("a", { staticClass: "navbar-brand", attrs: { href: "/" } }, [
                  _vm._v("Home"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "navbar-nav" }, [
              _c("li", { staticClass: "nav-item dropdown" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link dropdown-toggle",
                    attrs: { "data-toggle": "dropdown" },
                  },
                  [_vm._v("\n                    Account\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-menu dropdown-menu-right" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "/#/organizations/users/dashboard" },
                      },
                      [_vm._v("My dashboard")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "/#/organizations/users/account" },
                      },
                      [_vm._v("Manage your account")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "/organizations/sessions/close" },
                      },
                      [_vm._v("Sign out")]
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }